import { getAboutInfo } from "@/api/landing";

export default {
  namespaced: true,
  state: {
    loading: false,
    aboutInfo: null,
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ABOUT_INFO(state, aboutInfo) {
      state.aboutInfo = aboutInfo
    },
  },
  actions: {
    async loadAboutInfo({ commit, state }) {
      if (state.aboutInfo !== null && state.aboutInfo !== undefined) {
        return;
      }
      commit("SET_LOADING", true);
      try {
        const response = await getAboutInfo();
        commit("SET_ABOUT_INFO", response.data);
      } catch (error) {
        console.error("Ошибка загрузки:", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    getAboutInfo: (state) => state.aboutInfo,
    isAboutInfoLoading: (state) => state.loading,
  },
};
